module.exports = __webpack_public_path__ + "assets/img/star_sentence1.158d25e4.png";